<template>
    <div class="flex-1">
        <div class="row mx-5 mt-5" v-if="loadError">
          <div class="alert alert-danger" role="alert">
            Неполучилось загрузить данные. Попробуйте перезагрузить страницу.
          </div>
        </div>
        <h4 class="px-5 py-5">Настройки - Приложение</h4>
        <div class="d-flex flex-column flex-grow px-5">
            <div class="row">
                <div class="col-md-8">
                        <div v-if="isAdmin === 'yes'" class="form-group">
                            <label for="select_track">Выберите поле трек-номера:</label>
                            <select class="form-control col-md-6" id="select_track" v-model="input">
                                <option v-for="(item, i) in fields" :key="i" v-bind:value="item.name" v-bind:name1=" item.name" v-bind:ff_name="ff_name">
                                    <template v-if="!item.label">{{ item.title }} [{{ item.name }}]</template>
                                    <template v-else>{{ item.label }} [{{ item.title }}]</template>
                                </option>
                            </select> 
                            <p class="save-t">Предыдущее значение: {{ ff_name }}</p>
                        </div>
                        <button v-if="isAdmin === 'yes'" type="button" class="btn btn-primary mb-4" v-on:click="saveTrack">Сохранить</button>
                        <div v-if="isAdmin === 'yes'" class="form-group">
                          <label style="font-size: 18px; font-weight: bold;">Пользовательское поле для проверки:</label><br>
                          <p style="font-size: 13px;">Благодаря этому полю вы можете сразу запустить проверку трек-номера, после “Добавления пользовательского поля”, перейдите в раздел Сделки и нажмите “Добавить поле”, выберите “Трекер посылок 2”. Работает с приложения 2 версии. <a href="https://tracker2.bitrix24.site/pomoshch/" target="_blank">Узнать подробнее</a></p>
                          <button type="button" class="btn btn-primary" @click="userFieldMount">{{ isMountedField ? 'Удалить из пользовательских полей' : 'Добавить пользовательское поле' }}</button>
                        </div>
                        <div v-show="alert_s_show" class="mt-2 alert alert-success my-3" role="alert" v-text="alert_s"></div>
                        <div v-show="alert_e_show" class="mt-2 alert alert-danger" role="alert" v-text="alert_e"></div>
                </div>
                <div class="col-md-4 sp-c">
                    <i class="fas fa-question"></i> Помощь
                    <p>
                        Из выбранного поля будет считывать трек-номер для каждой сделки. Вы можете выбрать любое. Значение по умолчанию: "Трек-номер (Трекер)"
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Bitrix24 from '@/lib/Bitrix24'
import config from '@/../config.js'
import axios from 'axios'
import app_config from '@/app_config'
import common from '@/lib/common'
import urls from '@/lib/urls'

export default {
  name: 'App',
  data: function () {
    return {
      fields: [],
      input: '',
      domain: '',
      loadError: false,
      alert_s: '',
      alert_s_show: false,
      alert_e: '',
      alert_e_show: false,
      ff_name: '',
      isMountedField: false,
      isAdmin: 'loading',
    }
  },

  async created() {
    const self = this

    let auth_info = await Bitrix24.getAuthInfo()

    if(auth_info){
      let domain = auth_info.domain
      this.domain = auth_info.domain
      let token = auth_info.access_token
      await common.authorization(token, domain).then(async response => {
        if(response){
          axios.get(urls.getSettings, await common.setAuthorizationHeader()).then((response) => {
            response = response.data

            self.ff_name = response.field_name
            self.input = self.ff_name
          }).catch(error => {
            let errorParsed = common.errorQueryHandler(error)

            if(errorParsed.type === 'unauthorization'){
              common.queryRefreshToken(error).then(response => {
                response = response.data

                self.ff_name = response.field_name
                self.input = self.ff_name
              }).catch(err => {
                self.loadError = true
                console.log(err)
              })
            } else if(errorParsed.type === 'some'){
              self.loadError = true
              console.log(error)
            } else{
              self.loadError = true
              console.log(error)
            }
          })
        }
      }).catch(error => {
        console.log(error)
      })
    }

    await this.isMountedFieldCheck()

    let fields = await Bitrix24.callMethod('crm.deal.fields', {})

    if(fields){
      if(fields.status === 200){
        var data = fields.answer.result;

        var a = Array.from(Object.keys(data), k => data[k])
        var b = []
        Object.keys(data).map((e) => {
          b.push({
            "title": data[e].title,
            "name": e,
            "label": data[e].listLabel
          })
        })
        self.fields = b
        self.isAdmin = 'yes'
      } else if(fields.status === 400){
        self.alert_e = 'У вас недостаточно прав, нужны права администратора портала!'
        self.alert_e_show = true
        self.isAdmin = 'no'
      } else{
        console.log(fields.error())
      }
      
    }
    // BX24.init(function () {
    //   BX24.callMethod(
    //     "crm.deal.fields", {},
    //     function (result) {
    //       if (result.error())
    //         console.error(result.error());
    //       else
    //         var data = result.answer.result;

    //       var a = Array.from(Object.keys(data), k => data[k])
    //       var b = []
    //       Object.keys(data).map((e) => {
    //         b.push({
    //           "title": data[e].title,
    //           "name": e,
    //           "label": data[e].listLabel
    //         })
    //       })
    //       self.fields = b
    //     }
    //   );
    // });
  },
  methods: {
    async isMountedFieldCheck() {
      const self = this
      let result = await Bitrix24.isMountedField()
      return new Promise((resolve, reject) => {
        if (result && result.status === 200) {
          let fields = result.answer.result
          let isField = fields.find(e => e.USER_TYPE_ID === 'tracker2userfield')
          if (isField) {
            resolve(true)
            this.isMountedField = true
          } else {
            this.isMountedField = false
            resolve(false)
          }
        } else if (result && result.status === 403) {
          this.isMountedField = false
          resolve(false)
          self.alert_e = 'У вас недостаточно прав, нужны права администратора портала!'
          self.alert_e_show = true
        } else {
          this.isMountedField = false
          resolve(false)
          self.alert_e = 'Возникла ошибка, попробуйте перезагрузить страницу!'
          self.alert_e_show = true
        }
      })
    },

    async userFieldMount() {
      let userTypeId = 'tracker2userfield'
      if (await this.isMountedFieldCheck()) {
        let result = await Bitrix24.unmountUserField({
          USER_TYPE_ID: userTypeId
        })
        if (result && result.status === 200) {
          this.alert_s = 'Пользовательское поле успешно удалено!'
          this.alert_s_show = true
        } else {
          this.alert_e = 'Возникла ошибка, пользовательское поле не удалено!'
          this.alert_e_show = true
        }
        this.isMountedField = await this.isMountedFieldCheck()
      } else {
        let result = await Bitrix24.mountUserField({
          USER_TYPE_ID: userTypeId,
          HANDLER: urls.FIELD,
          TITLE: config.title
        })
        if (result && result.answer.result === true) {
          this.alert_s = 'Пользовательское поле добавлено!'
          this.alert_s_show = true
        } else {
          this.alert_e = 'Возникла ошибка, пользовательское поле не добавлено!'
          this.alert_e_show = true
        }
        this.isMountedField = await this.isMountedFieldCheck()
      }
    },


    saveTrack: async function () {
      if (this.input === '') {
        this.alert_s = ''
        this.alert_e = 'Пожалуйста выберите поле трек-номера.'
        this.alert_s_show = false
        this.alert_e_show = true
      } else {
        var postData = {
          domain: this.domain,
          field_name: this.input
        }
        this.alert_s = ''
        this.alert_e = ''
        this.alert_s_show = false
        this.alert_e_show = false
        const self = this

        axios.post(urls.saveField, postData, await common.setAuthorizationHeader()).then(response => {
          if (response.status === 200) {
            self.alert_s = 'Успешно'
            self.ff_name = self.input
            self.alert_s_show = true
          }
        }).catch(error => {
          let errorParsed = common.errorQueryHandler(error)

          if(errorParsed.type === 'unauthorization'){
            common.queryRefreshToken(error).then(response => {
              if (response.status === 200) {
                self.alert_s = 'Успешно'
                self.ff_name = self.input
                self.alert_s_show = true
              }
            }).catch(err => {
              self.alert_e = error
              self.alert_e_show = true
              console.log(err)
            })
          } else if(errorParsed.type === 'some'){
            self.alert_e = error
            self.alert_e_show = true
            console.log(error)
          } else{
            self.alert_e = error
            self.alert_e_show = true
            console.log(error)
          }
        })
      }
    },
  },
}
</script>
<style scope>
.save-t{
    color: #8c8c8c;
    font-size: 14px;
}
</style>
